import { sortFolderRecordsByName } from "../useFloorPlanFolderRecords/utils";
import type { FloorPlanRecord } from "components/SmartSurveyor/SmartSurveyorForRudolfFritz/hooks/types";
import type { FloorPlanFolderRecord } from "../../utils/types";

export const resolvePlanRecordIndex = (
  records: FloorPlanRecord[],
  idParam: number | null,
): number | null => {
  if (idParam === null) return null;
  const index = records.findIndex((record) => record.id === idParam);
  return index >= 0 ? index : null;
};

export const findFirstPlanIndexInFirstFolder = (
  records: FloorPlanRecord[],
): number | null => {
  const foldersWithActivePlans: FloorPlanFolderRecord[] = [];
  for (const record of records) {
    if (record.archivedAt === null && record.folder) {
      foldersWithActivePlans.push(record.folder);
    }
  }
  const [firstFolder] = sortFolderRecordsByName(foldersWithActivePlans);
  if (firstFolder === undefined) return null;
  return records.findIndex(
    (record) =>
      record.archivedAt === null && record.folderId === firstFolder.id,
  );
};

export const findFirstActivePlanIndex = (
  records: FloorPlanRecord[],
): number | null => {
  const index = records.findIndex((record) => record.archivedAt === null);
  return index >= 0 ? index : null;
};

export const findFirstArchivedPlanIndex = (
  records: FloorPlanRecord[],
): number | null => {
  const index = records.findIndex((record) => record.archivedAt !== null);
  return index >= 0 ? index : null;
};
